import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'Technology company Lebanon, top business holdings in Middle East, leading technology company Lebanon',
        Description:'Resource Group Holding is a leading business group englobing more than eleven industries under one roof. Especialized in technical solutions, Resource Group holding has presence in the Middle East, Africa, Europe and West Asia.',
        Keywords:'turn key technical solutions, technology company, leading business holding company',
        component: 'appPageHome',
        index: 0,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/resourcegroup-headquarters-beirut-lebanon',
      name: 'home',
      meta: {
        title: 'Resource Group headquarters Lebanon, Resource Group market coverage Middle East, Resource Group production plants Africa',
        Description:'Headquartered in Beirut, Lebanon, the group operates via an established international network of offices and distributors.',
        Keywords:'',
        component: 'appPageHome',
        index: 0,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/about-resourcegroup-holding',
      name: 'AboutUs',
      meta: {
        title: 'Investment Group Middle East, total solutions systems providers, technical systems providers',
        Description:'Resource Group operates across the sectors of security printing, smartcard technologies, identification & payments solutions, mobile Value Added Services (VAS), supply chain services, telecom infrastructure & managed services, real estate development, lottery operations and gaming.',
        Keywords:'Telecommunication services, security printing company in the Middle East, security and technology companies, security printing documents providers, telecom infrastructure services, smartcards manufacturer, supply chain management in the Middle East.',
        component: 'appPageHowweare',
        index: 1,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/about-hisham-itani',
      name: 'AboutUsHishamItani',
      meta: {
        title: 'Resource Group chairman Hisham Itani, top business men Lebanon, leading entrepreneurs Middle East, Lebanese Visionnary',
        Description:'Hisham Itani is a the Chairman of Resource Group. His passion for entrepreneurship coupled with his keen sense for business made him one of the most sussessful business men and company owners in the whole region.',
        Keywords:'Resource Group Holding CEO, business men in Lebanon, famous business men in the Middle East, Resource Group owner, entrepreneurs in Lebanon, business visionnary, best CEO in Middle East',
        component: 'appPageHowweare',
        index: 1,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/community-csr-program',
      name: 'communitycsrprogram',
      meta: {
        title: 'Investment Group Middle East, total solutions systems providers, technical systems providers',
        Description:'Investment Group Middle East, total solutions systems providers, technical systems providers',
        Keywords:'CSR program, social responsibility program, economic growth, market growth',
        component: 'appPageHowweare',
        index: 1,
        headerColor: 'clear'
      }
    }
    ,
    {
      path: '/resourcegroup/en/mission-vision-values',
      name: 'missionvisionvalues',
      meta: {
        title: 'Resource Group mission, company vision, Resource Group values',
        Description:'The mission of Resource Group is to build and transform. The vision of Resource Group is to strive for success and its values are leadership, dedication, teamwork, transparency and excellence.',
        Keywords:'',
        component: 'appPageHowweare',
        index: 1,
        headerColor: 'clear'
      }
    }
    ,
    {
      path: '/resourcegroup/en/our-team',
      name: 'ourteam',
      meta: {
        title: 'Resource Group team, Resource Group employees, success collaborators',
        Description:': At Resource Group , talent is rewarded, career growth opportunities are offered, and equity and respect for the individual are fundamental.',
        Keywords:'',
        component: 'appPageHowweare',
        index: 1,
        headerColor: 'clear'
      }
    }
    ,
     {
      path: '/resourcegroup-subsidiaries',
      name: 'home',
      meta: {
        title: 'Inkript Industries,Inmobiles,Intragate Studios,Numberbook,Inkript Technologies,Serta,Intersektion,Game Cooks ',
        Description:'Mobile games makers,Lottery and Gaming Operator,Information and Communication Technology Solutions Provider,Identification Solutions Provider,Community Application,Lottery and Betting System Provider,Mobile Applications Development,Security Printing Services',
        Keywords:'Security printing services in Lebanon, security printing entreprise in the Middle East, Security and technology companies in Europe, sim card manufacturer in Lebanon, smartcards manufacturer in Lebanon.,Mobile applications development in Lebanon, mobile services company in Lebanon, mobile apps makers, mobile application provider, mobile applications developpers, network service provider in the Middle East,Lottery and betting system provider Lebanon, lottery and betting platforms, lottery systems, betting systems, bingo, sports betting games, jackpots, virtual games, mobile lottery, web lottery games, lottery machine manufacturer in the Middle East.,community application, play sotre apps, apps for mobile, app store, phone numbers search app ,play sotre apps downloads, mobile apps, android apps, ios apps, mobile apps creator, play store applications,Identification solutions provider, biometric access contorl system, biometric passports, fingerprint, biometrics, biometric technology in the middle east, biometric travel document solutions, biometric smart cards provider, biometric identification center in the Middle East,Information solutions provider in the Middle East, wireless services, wifi solutions, voice, data, mobile infrastructure solutions, secure communications, cybersecurity solutions, infrastructure provider in the Middle East and Africa, communication technology provider in Africa.Lottery operators in Europe, lottery and gaming, gaming operators, lottery operators, gaming operators in the Middle East, lottery & gaming in Africa,Mobile games makers, mobile games developers, play store games, download games, new mobile games, latest mobile games, mobile games programmers, android mobile games, ios games, mobiles games development companies in Lebanon',
        component: 'appPageSubsidiaries',
        index: 2,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/business-industries-sectors',
      name: 'sectors',
      meta: {
        title: 'security printing Lebanon, supply chain services, telecom services, real estate development, lottery operations and gaming Middle East',
        Description:'Resource Group is a holding that encompasses diverse industries among which are security printing, real estate development, telecom infrastructure services, supply chain management, etc.',
        Keywords:'telecom infrastructure services, security printing, real estate development.',
        component: 'appPageSectors',
        index:3,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/careers-job-opportunities-vacancies-lebanon',
      name: 'careers',
      meta: {
        title: 'Resource Group job opportunities Lebanon, Resource Group careers, Resource Group job opening, Resource Group job vacancies',
        Description:'Submit your CV  and we will contact you should your profile match any of our current vacancies.',
        Keywords:'',
        component: 'appPageCareers',
        index: 4,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/resourcegroup-media-news-articles',
      name: 'news',
      meta: {
        title: 'News about Resource Group, Resource Group latest news, articles about Resource Group',
        Description:'In this section you can check the latest news about Resource Group  and all the artciles that are related to our company\'s events and activities.',
        Keywords:'',
        component: 'appPageNews',
        index: 5,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/contact-address-number-lebanon',
      name: 'Contact',
      meta: {
        title: 'Resource Group contact details Lebanon, Resource Group  phone number Lebanon, Resource Group address Lebanon',
        Description:'Check our phone number, address and full contact details on our "contact us" section.',
        Keywords:'',
        component: 'appPageContact',
        index: 6,
        headerColor: 'clear'
      }
    }
  ,
  {
      path: '/resourcegroup/en/resourcegroup-media-news-articles/:slug',
      name: 'newsInside',
      meta: {
        title: 'News about Resource Group, Resource Group latest news, articles about Resource Group',
        Description:'In this section you can check the latest news about Resource Group  and all the artciles that are related to our company\'s events and activities.',
        Keywords:'',
        component: 'appPageNews',
        index: 8,
        headerColor: 'clear'
      }
    },
    {
      path: '/resourcegroup/en/careers-job-opportunities-vacancies-lebanon/:slug',
      name: 'careersInside',
      meta: {
        title: 'Resource Group job opportunities Lebanon, Resource Group careers, Resource Group job opening, Resource Group job vacancies',
        Description:'Submit your CV  and we will contact you should your profile match any of our current vacancies.',
        Keywords:'',
        component: 'appPageCareers',
        index: 8,
        headerColor: 'clear'
      }
    },
     {
      path: '/terms-and-conditions',
      name: 'me',
      meta: {
        title: 'Resource Group | Terms and conditions',
        component: 'appPageTermsAndConditions',
        index: 9,
        headerColor: 'clear'
      }
    }, {
      path: '*',
      name: '404',
      meta: {
        component: 'appPage404',
        title: 'Resource Group  | 404',
        headerColor: 'clear'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/application/router.js